import { createAction } from 'redux-actions';

const PREFIX = 'SCHEDULES_BOOKING_PAYMENTS';

export const getSchedules = createAction(`${PREFIX}/loadSSchedules`);

export const saveSchedules = createAction(`${PREFIX}/saveSchedules`);
